import Main from '../../types/enums/main';
import Rail from '../../classes/rail';
import channelsCornerRequest from './channelsCornerRequest';
import contentRequest from './contentRequest';
import generateChannelsRailsWithData from '../../utils/generic/generateChannelsRailsWIthData';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

function contentObservable(id: string, title: string) {
  return new Observable((subscriber) => {
    let data: Rail[] = [];
    channelsCornerRequest({ corner: id }).then((channelList) => {
      const [channelRail] = generateChannelsRailsWithData(
        channelList || [],
        title
      );
      if (channelRail?.data?.length) {
        data = data.concat(channelRail);
      }
      contentRequest(id).then((contentData) => {
        setTimeout(() => {
          subscriber.next({ data: data.concat(contentData), type: Main.RAILS });
          subscriber.complete();
        }, WAITING_TIME);
      });
    });
  });
}

export default contentObservable;
